import { Vue, Component, Prop, Emit, Watch} from 'vue-property-decorator';

import TkForm from '@/../bower_components/teknisavuecomponents/components/TkForm.vue';
import EditableTable from '@/../bower_components/teknisavuecomponents/components/grids/EditableTable.vue';
import Util from '@/../bower_components/teknisavuecomponents/assets/utils/Util';
import ToolbarAction from '@/../bower_components/teknisavuecomponents/assets/interfaces/ToolbarAction';
import SnackbarUtils from '@/../bower_components/teknisavuecomponents/assets/utils/SnackbarUtils';
import Field from 'bower_components/teknisavuecomponents/assets/interfaces/Field';
import { SolicitacaoController } from '@/assets/ts/controller/SolicitacaoController';


@Component({
  name: 'DadosVinculoPopup',
  components: {
    TkForm,
    EditableTable,
  },
})
class DadosVinculoPopup extends Vue {

  @Prop({ default: false })
  private readonly value: boolean;

  @Prop({ default: () => {} })
  private readonly numeroVinculo!: number;

  private loading = false;
  

  private row: any = {};

  private fieldsMap = {
    dadosVinculo: ['NRVINCULOM', 'NMVINCULOM', 'NRESCALATRABM', 'NMESCALATRABH', 'NROCUPACAOM', 'NMOCUPACAOH'],
  };


  private internalValue = false;

  @Emit('input')
  private emitInput(value: boolean) {}

  private get fields(): Field[] {
    const fields: Field[] = [
      {
        name: 'NRVINCULOM',
        label: 'Nr. Vínculo',
        valueField: 'NRVINCULOM',
        size: 6,
        type: 'text',
      },
      {
        name: 'NMVINCULOM',
        label: 'Vínculo',
        valueField: 'NMVINCULOM',
        size: 6,
        type: 'text',
      },
      {
        name: 'NRESCALATRABM',
        label: 'Nr. Escala de Trabalho',
        valueField: 'NRESCALATRABM',
        size:6,
        type: 'text',
      },
      {
        name: 'NMESCALATRABH',
        label: 'Escala de Trabalho',
        valueField: 'NMESCALATRABH',
        size:6,
        type: 'text',
      },
      {
        name: 'NROCUPACAOM',
        label: 'Nr. Ocupação',
        valueField: 'NROCUPACAOM',
        size:6,
        type: 'text',
      },
      {
        name: 'NMOCUPACAOH',
        label: 'Ocupação',
        valueField: 'NMOCUPACAOH',
        size:6,
        type: 'text',
      },
    ];

    return fields;
  }
  // #region [ WATCHERS ]
  @Watch('value', { immediate: true })
  private valueOnChange() {
    this.internalValue = this.value;
  }
  // 
  @Watch('numeroVinculo', { immediate: true, deep: true })
  private onDadosVinculoChange(newVal: any[]) {
    if (newVal) {
      this.onShowPopup();
    }
  }
  // #endregion

  private closeDialog(): void {
    this.internalValue = false;
    this.emitInput(this.internalValue);
  }

  // #region [ LIFECYCLE ]
  private created() {
    this.internalValue = this.value;

  }
  // #endregion

  // [ METHODS ]
  @Watch('isVisible', { immediate: true, deep: true })
  private isVisibleOnChange(newValue: boolean) {
    if (newValue) {
      this.onShowPopup();
    }
  }

  private onShowPopup() {
    this.setFields();
  }

  private async setFields() {
    if(typeof this.numeroVinculo == 'number') {
      const dadosVinculoRetorno = await SolicitacaoController.getDadosVinculo(this.numeroVinculo);
      const rowCopy = Util.deepCopy(this.row);
  
      const populateFields = (fields: string[], target: any, source: any) => {
        fields.forEach(fieldName => {
          if (fieldName in source) {
            target[fieldName] = source[fieldName];
          }
        });
      };
  
  
      populateFields(this.fieldsMap.dadosVinculo, rowCopy, dadosVinculoRetorno);
  
      this.$nextTick(() => {
        this.row = rowCopy;
      });  
    }  
  }

    // #endregion

}

export default DadosVinculoPopup;
